import React, { useRef, useState, useEffect } from "react";
import ReviewItem from "./ReviewItem";
import { useTranslation } from 'react-i18next';

const ReviewList = ({ currentTherapist }) => {
  const { t, i18n } = useTranslation('therapist');
  const parsedAvis = currentTherapist?.ratings || [];
  const positiveReviews = parsedAvis.filter((review) => review.rating >= 0);
  const sortedReviews = positiveReviews.sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );

  const reviewsRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - reviewsRef.current.offsetLeft);
    setScrollLeft(reviewsRef.current.scrollLeft);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - reviewsRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    reviewsRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div className="review-list" style={{ marginTop: "30px" }}>
      <div className="modal-therapist">
        <h3 className="info-title" style={{ padding: 0 }}>
          {t('avis')} ({sortedReviews.length} {t('avis')})
        </h3>
        <div
          className="reviews"
          ref={reviewsRef}
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
          style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
        >
          {sortedReviews.map((review, index) => (
            <div key={index} className="review-item-container">
              <ReviewItem review={review} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewList;
